/**
=========================================================
* BAXI NOVA - Servicio Técnico Oficial
=========================================================

* Copyright 2025 BAXI NOVA
* Servicio Técnico Oficial de Calderas y Calefacción

=========================================================
*/

import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

const container = document.getElementById("root");

// Create a root.
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
